// utils/assignColors.ts

const COLORS = [
  "bg-red-500",
  "bg-blue-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-purple-500",
  "bg-indigo-500",
  "bg-pink-500",
  "bg-teal-500",
];

/** Deterministic hash from string to number - same id always gets same color */
const hashToIndex = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
};

export const assignColors = (people: any[]): Record<string, string> => {
  const assignedColors: Record<string, string> = {};
  people.forEach((person) => {
    if (person && person.id) {
      const index = hashToIndex(person.id) % COLORS.length;
      assignedColors[person.id] = COLORS[index];
    }
  });
  return assignedColors;
};
